/**
 * Helper function to merge primary and secondary document languages for a given country.
 * Returns a unique array of document language IDs, falling back to the provided fallback language if empty.
 *
 * @param primaryDocumentLanguages - Record of primary document languages by country
 * @param secondaryDocumentLanguages - Record of secondary document languages by country
 * @param countryID - The country ID to get languages for (case-insensitive)
 * @param fallbackLanguageID - The fallback language ID to use if no languages are found
 * @returns Array of unique document language IDs
 */
export function mergeDocumentLanguages(
  primaryDocumentLanguages: Record<string, string[]> | null,
  secondaryDocumentLanguages: Record<string, string[]> | null,
  countryID: string,
  fallbackLanguageID: string,
): string[] {
  const normalizedCountryID = countryID.toLowerCase();

  const documentLanguages = [
    ...new Set([
      ...(primaryDocumentLanguages?.[normalizedCountryID] ?? []),
      ...(secondaryDocumentLanguages?.[normalizedCountryID] ?? []),
    ]),
  ];

  if (!documentLanguages.length) {
    documentLanguages.push(fallbackLanguageID);
  }

  return documentLanguages;
}
